import axios from 'axios';
import { useEffect, useState } from 'react';
import { AiFillDelete, AiFillEdit } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Navbar from '../../components/Navbar';
import ld from '../../images/load.gif';
import styles from '../../styles/allproducts.module.css';

function AllProducts() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(null);
  const navigate = useNavigate();

  const getData = async () => {
    try {
      setLoading(true);
      const res = await axios.get('https://pro-shop-backend.vercel.app/api/products');
      if (res.data.success) {
        setData(res.data.message);
      } else {
        toast.error(res.data.message || 'Failed to fetch products', {
          position: 'bottom-right',
          theme: 'colored'
        });
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      const errorMessage = error.response?.data?.message || 'Failed to fetch products. Please try again.';
      toast.error(errorMessage, {
        position: 'bottom-right',
        theme: 'colored'
      });
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const deleteHandler = async (product) => {
    if (!window.confirm(`Are you sure you want to delete product: ${product.name}?`)) {
      return;
    }

    try {
      setActionLoading(product._id);
      const res = await axios.delete(`https://pro-shop-backend.vercel.app/api/products/${product._id}`);
      
      if (res.data.success) {
        toast.success(res.data.message || 'Product deleted successfully', {
          position: 'bottom-right',
          theme: 'colored'
        });
        getData();
      } else {
        toast.error(res.data.message || 'Failed to delete product', {
          position: 'bottom-right',
          theme: 'colored'
        });
      }
      setActionLoading(null);
    } catch (error) {
      setActionLoading(null);
      const errorMessage = error.response?.data?.message || 'Failed to delete product. Please try again.';
      toast.error(errorMessage, {
        position: 'bottom-right',
        theme: 'colored'
      });
    }
  };

  return (
    <div className={styles.allProductsContainer}>
      <Navbar />

      <div className={styles.allProductsContent}>
        <div className={styles.headerSection}>
          <div className={styles.headerLeft}>
            <h3 className={styles.pageTitle}>All Products</h3>
            <span className={styles.productCount}>
              {data ? `${data.length} products found` : 'Loading...'}
            </span>
          </div>
          <button
            type="button"
            className={styles.createButton}
            onClick={() => navigate('/admin/createproduct')}
          >
            + Create Product
          </button>
        </div>

        {loading ? (
          <div className={styles.loadingContainer}>
            <img src={ld} className={styles.loaderImage} alt="Loading..." />
          </div>
        ) : data && data.length > 0 ? (
          <div className={styles.tableWrapper}>
            <table className={styles.productsTable}>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Price</th>
                  <th>Category</th>
                  <th>Brand</th>
                  <th>Stock</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {data.map((product) => (
                  <tr key={product._id} className={styles.tableRow}>
                    <td className={styles.productId}>{product._id.slice(0, 8)}...</td>
                    <td className={styles.productName}>{product.name}</td>
                    <td className={styles.productPrice}>${product.price}</td>
                    <td>
                      <span className={styles.categoryBadge}>{product.category || 'N/A'}</span>
                    </td>
                    <td>{product.brand}</td>
                    <td>
                      <span className={product.countInStock > 0 ? styles.inStock : styles.outOfStock}>
                        {product.countInStock > 0 ? `${product.countInStock} in stock` : 'Out of Stock'}
                      </span>
                    </td>
                    <td>
                      <div className={styles.actionButtons}>
                        <button
                          className={styles.editBtn}
                          onClick={() => navigate(`/admin/editproduct/${product._id}`)}
                          disabled={actionLoading === product._id}
                        >
                          <AiFillEdit className={styles.editIcon} />
                        </button>
                        <button
                          className={styles.deleteBtn}
                          onClick={() => deleteHandler(product)}
                          disabled={actionLoading === product._id}
                        >
                          {actionLoading === product._id ? (
                            <img src={ld} className={styles.smallLoader} alt="loading" />
                          ) : (
                            <AiFillDelete className={styles.deleteIcon} />
                          )}
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className={styles.noProducts}>
            <div className={styles.noProductsIcon}>📦</div>
            <p>No products found</p>
            <button
              type="button"
              className={styles.createButtonEmpty}
              onClick={() => navigate('/admin/createproduct')}
            >
              Create Your First Product
            </button>
          </div>
        )}
      </div>

      <ToastContainer
        position="bottom-right"
        theme="colored"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default AllProducts;